import { Grid, useTheme } from '@mui/material'
import { C1Button } from 'c1ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useStyles } from './styles'

export enum PaginationType {
    paged,
    infinite,
}

type PaginationProps = {
    type: PaginationType
    currentPageToken: string
    previousPageTokens: string[]
    setPreviousPageTokens: React.Dispatch<React.SetStateAction<string[]>>
    nextPageToken: string
    onPageChange: (pageToken: string) => void
}

export const Pagination = ({
    type,
    currentPageToken,
    previousPageTokens,
    setPreviousPageTokens,
    nextPageToken,
    onPageChange,
}: PaginationProps): React.ReactElement => {
    const theme = useTheme()
    const classes = useStyles(theme)

    const next = () => (): void => {
        setPreviousPageTokens([...previousPageTokens, currentPageToken])
        onPageChange(nextPageToken)
    }

    const previous = () => (): void => {
        const previousPageToken = previousPageTokens.pop()
        setPreviousPageTokens([...previousPageTokens])
        onPageChange(previousPageToken || '')
    }

    if (type === PaginationType.infinite) {
        return (
            <>
                {nextPageToken && (
                    <C1Button
                        className={classes.loadMoreButton}
                        onClick={next()}
                        variant="outlined"
                        color="primary"
                        fullWidth
                    >
                        <FormattedMessage id="load_more" defaultMessage="Load more" />
                    </C1Button>
                )}
            </>
        )
    }

    return (
        <Grid container spacing={1} direction="row-reverse" className={classes.paginationConatiner}>
            <Grid item>
                <C1Button disabled={nextPageToken === ''} onClick={next()} variant="outlined" color="primary">
                    <FormattedMessage id="next_page" defaultMessage="Next" />
                </C1Button>
            </Grid>
            <Grid item>
                <C1Button
                    disabled={previousPageTokens.length === 0}
                    onClick={previous()}
                    variant="outlined"
                    color="primary"
                >
                    <FormattedMessage id="previous_page" defaultMessage="Previous" />
                </C1Button>
            </Grid>
        </Grid>
    )
}
